import { z } from 'zod'

import { baseRegistrySchema } from '@/registry'
import { docVersionSchema, entitySchema } from '@/utility'

export const managedSchemaVersion = entitySchema
  .extend({
    /** Version identifier (e.g. 0.0.1) for schema */
    version: docVersionSchema.default('0.0.1'),
  })
  .meta({ id: 'managed-schema-version' })

export type ManagedSchemaVersion = z.infer<typeof managedSchemaVersion>

export const managedSchemaFormat = z
  .enum(['json', 'yaml'])
  .meta({ id: 'managed-schema-format' })

export type ManagedSchemaFormat = z.infer<typeof managedSchemaFormat>

export const managedSchema = baseRegistrySchema
  .extend({
    /** The current version served to consumers by default */
    version: docVersionSchema.default('0.0.1'),
    /** All schema versions */
    versions: managedSchemaVersion.array(),
    /** Default schema format for edit/view */
    format: managedSchemaFormat.default('json'),
  })
  .meta({ id: 'managed-schema' })

export type ManagedSchema = z.infer<typeof managedSchema>
